export default __webpack_public_path__ + "static/media/product-image-1.03cdc5e0.png";